import { DIMENSIONS, type DimensionId } from "./dimensions";

export type FilterField = (typeof FILTER_FIELDS)[number]["value"] | undefined;
export const FILTER_FIELDS = [
  {
    label: "Organization",
    value: "organization_name",
  },
  {
    label: "Campaign Type",
    value: "campaign_type",
  },
  {
    label: "Placement Type",
    value: "placement_type",
  },
  {
    label: "Ad Type",
    value: "ad_type",
  },
  {
    label: "Audience",
    value: "audience",
  },
  {
    label: "Partner",
    value: "partner",
  },
  {
    label: "Country",
    value: "country",
  },
  {
    label: "Supply Type",
    value: "supply_type",
  },
] as const;

export function filterWhereClause(filterField: FilterField, filterValue: string, dimensionId: DimensionId): string {
  const dimensionConfig = DIMENSIONS.find(dimension => dimension.id === dimensionId);
  if (!dimensionConfig) return "";
  if (dimensionConfig.dim1Field === filterField) {
    return `AND dim_val1 = '${filterValue}'`;
  }
  if (dimensionConfig.dim2Field === filterField) {
    return `AND dim_val2 = '${filterValue}'`;
  }
  return "";
}
